import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { logout } from '../actions/user';
import LogoutPage from '../components/Logout';

interface MapDispatchToProps {
  logout: () => (dispatch: Dispatch<AuthenticationAction>) => void
}

const mapDispatchToProps = (dispatch: Dispatch): MapDispatchToProps => bindActionCreators({
  logout
}, dispatch);

export default connect(undefined, mapDispatchToProps)(LogoutPage);
